import type { ReactNode } from 'react';

export const symbol_local_library: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M120-258v-308q0-26 20-44t46-16q86 8 158.5 52.5T480-469q63-60 135.5-104.5T774-626q26-2 46 16t20 44v308q0 23-16 40t-39 19q-73 6-142 35T517-90q-8 7-17.5 10T480-77q-10 0-19.5-3T443-90q-57-45-126-74t-142-35q-23-2-39-19t-16-40Zm360 121q71-51 146.5-81.5T780-257v-310q-68 11-143.5 54.5T480-392q-88-81-160-123t-140-52v310q78 8 153.5 38.5T480-137ZM373.5-656.5Q329-701 329-766t44.5-109.5Q418-920 483-920t109.5 44.5Q637-831 637-766t-44.5 109.5Q548-612 483-612t-109.5-44.5Zm176-43Q577-727 577-766t-27.5-66.5Q522-860 483-860t-66.5 27.5Q389-805 389-766t27.5 66.5Q444-672 483-672t66.5-27.5ZM483-766Zm-3 374Z"
		/>
	</svg>
);
